// extracted by mini-css-extract-plugin
export default {"container":"home_container__OnVYX","shopBtn":"home_shopBtn__6KjJD","products":"home_products__kFYXc","allProducts":"home_allProducts__4Xr8D"};